import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3886a67c&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/joelstorm/Sites/hanken-sse-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3886a67c', component.options)
    } else {
      api.reload('3886a67c', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=3886a67c&", function () {
      api.rerender('3886a67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/Pagination.vue"
export default component.exports